import { useContext, useEffect } from "react";
import clsx from "clsx";
import { useSection } from "@tree-company/tree-query";
import { LocaleContext } from "../../app";
import { ratingKey } from "../../survey";
import { BoostItem } from "./boost_item";

export function BoostSelection({ question, className, handleChange }) {
  const { translate } = useContext(LocaleContext);
  const { value, options } = useSection(question);
  const visibleOptions = options.filter((o) => !o.hide);
  const selected = value ?? [];

  // in case user goes back and sets previously selected rec to lower rating
  useEffect(() => {
    if (selected.length === 0) return;
    const visibleValues = new Set(visibleOptions.map((o) => o.value));
    const selectedAndVisible = selected.filter((v) => visibleValues.has(v));
    if (selectedAndVisible.length < selected.length) {
      question.value = selectedAndVisible;
    }
  }, [selected, visibleOptions, question]);

  const sortedOptions = visibleOptions
    .map((option) => ({
      option,
      rating: question.treesponse.getAnswer(ratingKey(option.value)),
    }))
    .sort((a, b) => b.rating - a.rating);

  if (sortedOptions.length === 0) {
    return (
      <div className={clsx("cards-wrapper", className)}>
        <p className="card boost-empty">{translate("boost.empty")}</p>
      </div>
    );
  }

  return (
    <div className={clsx("cards-wrapper", className)}>
      {sortedOptions.map(({ option, rating }) => {
        const isSelected = selected.includes(option.value);

        return (
          <BoostItem
            key={option.value}
            option={option}
            rating={rating}
            isSelected={isSelected}
            onToggle={handleChange}
          />
        );
      })}
    </div>
  );
}
